import { Center, Text } from '@chakra-ui/react';
import Pagination from 'modules/approve-transactions-v2/components/Pagination';
import TransactionTable from 'modules/approve-transactions-v2/components/TransactionTable';
import AlertMessage from 'components/AlertMessage/AlertMessage';
import Loader from 'components/Loader/Loader';

const TransactionList = ({
  transactions,
  isLoading,
  error,
  currentPage,
  totalPages,
  onPreviousPage,
  onNextPage,
  isNextDisabled,
  onTransactionClick,
  activeTab,
  hideApproveButton = false,
}) => {
  if (isLoading) return <Loader />;
  if (error) return <AlertMessage errorTitle='Error fetching transaction requests.' errorMessage={error?.message} />;
  if (!transactions.length) {
    return (
      <Center>
        <Text color='gray' mt={4}>
          No {activeTab === 0 ? 'pending' : 'settlement'} transaction requests found.
        </Text>
      </Center>
    );
  }

  return (
    <>
      <TransactionTable
        transactions={transactions}
        onTransactionClick={onTransactionClick}
        hideApproveButton={hideApproveButton}
      />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPreviousPage={onPreviousPage}
        onNextPage={onNextPage}
        isNextDisabled={isNextDisabled}
      />
    </>
  );
};

export default TransactionList;
